import React from "react";

type ActiveTab = "purpose" | "mcc";

interface PurposeMccHeaderProps {
  activeTab: ActiveTab;
  purposeCount: number;
  mccCount: number;
  onTabChange: (tab: ActiveTab) => void;
}

const PurposeMccHeader: React.FC<PurposeMccHeaderProps> = ({
  activeTab,
  purposeCount,
  mccCount,
  onTabChange,
}) => {
  return (
    <div className="bg-white rounded-xl p-5 sm:p-6 border-[1px] border-cardborder mb-5 sm:mb-6">
      <h1 className="text-2xl font-bold text-gray-900">Purpose Code Management</h1>
      <p className="text-sm text-gray-600 mt-1">
        Browse purpose codes and MCCs and inspect their mappings.
      </p>

      <div className="mt-6 flex flex-wrap items-center gap-2.5">
        <button
          type="button"
          onClick={() => onTabChange("purpose")}
          className={`px-4 py-2.5 text-sm rounded-md border ${
            activeTab === "purpose"
              ? "bg-brand text-white border-brand"
              : "bg-white text-gray-700 border-gray-300"
          }`}
        >
          Purpose Codes ({purposeCount})
        </button>
        <button
          type="button"
          onClick={() => onTabChange("mcc")}
          className={`px-4 py-2.5 text-sm rounded-md border ${
            activeTab === "mcc"
              ? "bg-brand text-white border-brand"
              : "bg-white text-gray-700 border-gray-300"
          }`}
        >
          MCC Codes ({mccCount})
        </button>
      </div>
    </div>
  );
};

export default PurposeMccHeader;
